import { render, staticRenderFns } from "./ManagerShiftEditorTeachers.vue?vue&type=template&id=212e6aaa&lang=pug&"
import script from "./ManagerShiftEditorTeachers.vue?vue&type=script&lang=js&"
export * from "./ManagerShiftEditorTeachers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports